import { TableCell } from 'ui/tableCell';
import type { OrganizationStatsTableColumnData, ProjectsStatsTableColumnData } from './types';

export const ORGANIZATIONS_STATS_TABLE_COLUMNS: OrganizationStatsTableColumnData[] = [
  {
    name: 'Active Users All Time',
    align: 'flex-start',
    value: 'activeUsersAddedInPeriod',
    RowCell: ({ row }) => <TableCell>{row.activeUsersAllTime}</TableCell>,
    sortable: false,
  },
  {
    name: 'Active Users Added in Period',
    align: 'flex-start',
    value: 'activeUsersAddedInPeriod',
    RowCell: ({ row }) => <TableCell>{row.activeUsersAddedInPeriod}</TableCell>,
    sortable: false,
  },
  {
    name: 'Emails Sent',
    align: 'flex-start',
    value: 'emailCount',
    RowCell: ({ row }) => <TableCell>{row.emailCount}</TableCell>,
    sortable: false,
  },
  {
    name: 'Pushes Sent',
    align: 'flex-start',
    value: 'pushCount',
    RowCell: ({ row }) => <TableCell>{row.pushCount}</TableCell>,
    sortable: false,
  },
  {
    name: 'SMSes Sent',
    align: 'flex-start',
    value: 'smsCount',
    RowCell: ({ row }) => <TableCell>{row.smsCount}</TableCell>,
    sortable: false,
  },
  {
    name: 'Total Product Recommendations',
    align: 'flex-start',
    value: 'productRecommendationCount',
    RowCell: ({ row }) => <TableCell>{row.productRecommendationCount}</TableCell>,
    sortable: false,
  },
  {
    name: 'Total Users All Time',
    align: 'flex-start',
    value: 'totalUsersAllTime',
    RowCell: ({ row }) => <TableCell>{row.totalUsersAllTime}</TableCell>,
    sortable: false,
  },
  {
    name: 'Total Users Added in Period',
    align: 'flex-start',
    value: 'totalUsersAddedInPeriod',
    RowCell: ({ row }) => <TableCell>{row.totalUsersAddedInPeriod}</TableCell>,
    sortable: false,
  },
];

export const PROJECT_STATS_TABLE_COLUMNS: ProjectsStatsTableColumnData[] = [
  {
    name: 'Project ID',
    align: 'flex-start',
    value: 'id',
    RowCell: ({ row }) => <TableCell>{row.id}</TableCell>,
  },
  {
    name: 'Active Users Added in Period',
    align: 'flex-start',
    value: 'activeUsersAddedInPeriod',
    RowCell: ({ row }) => <TableCell>{row.activeUsersAddedInPeriod}</TableCell>,
  },
  {
    name: 'Active Users All Time',
    align: 'flex-start',
    value: 'activeUsersAddedInPeriod',
    RowCell: ({ row }) => <TableCell>{row.activeUsersAllTime}</TableCell>,
  },
  {
    name: 'Emails Sent',
    align: 'flex-start',
    value: 'emailCount',
    RowCell: ({ row }) => <TableCell>{row.emailCount}</TableCell>,
  },
  {
    name: 'Org ID',
    align: 'flex-start',
    value: 'organizationId',
    RowCell: ({ row }) => <TableCell>{row.organizationId}</TableCell>,
  },
  {
    name: 'Project Enabled',
    align: 'flex-start',
    value: 'isArchived',
    RowCell: ({ row }) => <TableCell>{row.isArchived}</TableCell>,
  },
  {
    name: 'Project Name',
    align: 'flex-start',
    value: 'name',
    RowCell: ({ row }) => <TableCell>{row.name}</TableCell>,
  },
  {
    name: 'Pushes Sent',
    align: 'flex-start',
    value: 'pushCount',
    RowCell: ({ row }) => <TableCell>{row.pushCount}</TableCell>,
  },
  {
    name: 'SMSes Sent',
    align: 'flex-start',
    value: 'smsCount',
    RowCell: ({ row }) => <TableCell>{row.smsCount}</TableCell>,
  },
  {
    name: 'Total Product Recommendations',
    align: 'flex-start',
    value: 'productRecommendationCount',
    RowCell: ({ row }) => <TableCell>{row.productRecommendationCount}</TableCell>,
  },
  {
    name: 'Total Users Added in Period',
    align: 'flex-start',
    value: 'totalUsersAddedInPeriod',
    RowCell: ({ row }) => <TableCell>{row.totalUsersAddedInPeriod}</TableCell>,
  },
  {
    name: 'Total Users All Time',
    align: 'flex-start',
    value: 'totalUsersAllTime',
    RowCell: ({ row }) => <TableCell>{row.totalUsersAllTime}</TableCell>,
  },
];
